import { useEffect, useState } from "react";
import Navbar from "../components/sections/Navbar";
import Breadcrumb from "../components/ui/Breadcrumb";
import PageHeader from "../components/sections/PageHeader";
import Button from "../components/ui/Button";
import FilterBar from "../components/sections/FilterBar";
import ResponsTable from "../components/sections/ResponsTable";
import { useAuth } from "../context/AuthContext";
function Respons() {

    const [filters, setFilters] = useState({
        gemeente: "",
        jaar: "",
    });

    const [period, setPeriod] = useState("12m");
    const [filterOptions, setFilterOptions] = useState({ gemeentes: [], jaren: [] });
    const { tokens, isVerifying, authorizedFetch } = useAuth();

    useEffect(() => {
        if (isVerifying || !tokens?.access) return undefined;
        const controller = new AbortController();

        async function loadFilterOptions() {
            try {
                const [gemeenteResponse, jarenResponse] = await Promise.all([
                    authorizedFetch("/api/filters/", { signal: controller.signal }),
                    authorizedFetch("/api/respons_jaren/", { signal: controller.signal }),
                ]);
                if (!gemeenteResponse.ok || !jarenResponse.ok) {
                    throw new Error("Failed to load respons filters");
                }
                const [gemeenteData, jarenData] = await Promise.all([
                    gemeenteResponse.json(),
                    jarenResponse.json(),
                ]);
                if (!controller.signal.aborted) {
                    setFilterOptions({
                        gemeentes: gemeenteData.gemeentes || [],
                        jaren: jarenData.map((jaar) => ({ value: String(jaar), label: String(jaar) })),
                    });
                }
            } catch (error) {
                if (error.name !== "AbortError") {
                    console.error("Failed to load respons filters", error);
                }
            }
        }

        loadFilterOptions();
        return () => controller.abort();
    }, [tokens?.access, isVerifying, authorizedFetch]);

    const handleFilterChange = (name, value) => {
        setFilters((prev) => ({
            ...prev,
            [name]: value,
        }));
        if (name === "jaar" && value) {
            setPeriod("all");
        }
    };

    return (
        <div>
            {/* Navbar always at top */}
            <Navbar />
            <div className="container">
                <Breadcrumb icon="home-line.png" items={[]} current="Respons en bericht" />

                <PageHeader
                    title="Respons en bericht"
                    actions={
                        <>
                            <Button variant="secondary" icon="/icons/download-grijs.png" iconPosition="left" >
                                Exporteer organisaties
                            </Button>
                            <Button variant="primary" icon="/icons/download-paars.png" iconPosition="left" >
                                Export Report
                            </Button>
                        </>
                    }
                />

                <FilterBar
                    filters={filters}
                    period={period}
                    onChange={handleFilterChange}
                    onPeriodChange={setPeriod}
                    filtersConfig={["gemeente", "jaar", "periode"]}
                    options={filterOptions}
                />

                <ResponsTable filters={filters} period={period} />

            </div>
        </div>
    );
}

export default Respons;
